// extracted by mini-css-extract-plugin
module.exports = {"comments-aticle":"Comments_comments-aticle__fazn-"};